/** Shared styling for the trades sidebar's control and status copy. */
export const CONTROL_HINT_SX = {
    fontSize: '9.5px',
    color: 'text.disabled',
    lineHeight: 1.4,
};
